/**
 * Адреса окружения. Берутся из .env-файлов Vite на этапе сборки.
 *
 * Раньше эти URL были зашиты в код в четырёх местах, из-за чего тестовая сборка
 * ходила в боевой бэкенд. Значений по умолчанию здесь намеренно НЕТ: пусть сборка
 * упадёт с понятной ошибкой, чем молча уедет в прод.
 */

function required(name: string, value: string | undefined): string {
  if (!value) {
    throw new Error(
      `Не задана переменная окружения ${name}. Проверьте .env-файл для текущего режима сборки.`,
    )
  }
  return value
}

/** База REST API, со слешем на конце. Пример: https://example.test/api/v2/ */
export const API_BASE_URL = required('VITE_API_BASE_URL', import.meta.env.VITE_API_BASE_URL)

/** База вебсокета, без слеша на конце. Пример: wss://example.test */
export const WS_BASE_URL = required('VITE_WS_BASE_URL', import.meta.env.VITE_WS_BASE_URL)

/** Адрес самого веб-приложения, без слеша на конце. Используется в ссылках-приглашениях. */
export const APP_BASE_URL = required('VITE_APP_BASE_URL', import.meta.env.VITE_APP_BASE_URL)

/** Готовая ссылка-приглашение в канал. */
export function channelInviteLink(inviteToken: string | undefined | null): string {
  return `${APP_BASE_URL}/channel/${inviteToken ?? ''}/invite`
}

/**
 * Ссылка-приглашение в звонок (Zoom-style). Токен кладём в query, а не в путь:
 * Crypt-токен содержит base64-символы (в т.ч. «/»), которые ломают путь.
 */
export function callInviteLink(inviteToken: string): string {
  return `${APP_BASE_URL}/join?t=${encodeURIComponent(inviteToken)}`
}

/** Короткая ссылка-приглашение по коду: rooms.../j/<code>. */
export function shortInviteLink(code: string): string {
  return `${APP_BASE_URL}/j/${code}`
}

/**
 * Ссылка-приглашение для показа/копирования. Бэкенд отдаёт готовую короткую
 * ссылку в invite_url — её и даём клиентам (~40 символов вместо ~330).
 * Длинная ссылка из invite_token остаётся запасным вариантом: она продолжает
 * работать, в том числе в ответах, где invite_url ещё нет.
 */
export function inviteLinkOf(
  source: { invite_url?: string | null; invite_token?: string | null } | null | undefined,
): string {
  if (!source) return ''
  if (source.invite_url) return source.invite_url
  return source.invite_token ? callInviteLink(source.invite_token) : ''
}
